import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import EttersendelserCommon from "../../Detalj/Ettersendelser";

import { getMiljoEttersendelserEttersendelsebrevPdf } from "../../../../actions/miljoEttersendelsebrevActions";

const Ettersendelser = () => {
  const miljogebyrEttersendelser = useSelector((store) => store.miljogebyrEttersendelser);
  const bybetjenter = useSelector((store) => store.bybetjenter);
  const ettersendelser = useMemo(
    () => getEttersendelserFraBetjenter(miljogebyrEttersendelser, bybetjenter),
    [miljogebyrEttersendelser, bybetjenter]
  );

  const dispatch = useDispatch();

  const handleGetIleggelseEttersendelserEttersendelsebrevPdf = (
    miljogebyrEttersendelseBrevId
  ) => {
    dispatch(
      getMiljoEttersendelserEttersendelsebrevPdf(miljogebyrEttersendelseBrevId)
    );
  };
  return (
    <EttersendelserCommon
      ettersendelser={ettersendelser}
      getEttersendelserEttersendelsebrevPdf={
        handleGetIleggelseEttersendelserEttersendelsebrevPdf
      }
    />
  );
};

const getEttersendelserFraBetjenter = (ettersendelser, bybetjenter) => {
  if (!Array.isArray(bybetjenter)) return ettersendelser;
  const objectOfBybetjenter = Object.assign(
    {},
    ...bybetjenter.map((bybetjent) => ({ [bybetjent.id]: { ...bybetjent } }))
  );

  return (
    ettersendelser &&
    ettersendelser
      .filter((ettersendelse) => ettersendelse.betjentId)
      .map((ettersendelseFraBetjent) => {
        const bybetjent =
          objectOfBybetjenter[ettersendelseFraBetjent.betjentId];
        return {
          ...ettersendelseFraBetjent,
          tjenestenummer: bybetjent && bybetjent.nummer,
        };
      })
      .sort((a, b) => {
        if (a.ettersendelseDato > b.ettersendelseDato) {
          return -1;
        } else if (a.ettersendelseDato < b.ettersendelseDato) {
          return 1;
        } else {
          return 0;
        }
      })
  );
};

export default Ettersendelser;
